module.exports = __webpack_public_path__ + "img/linked-in.ea0012ad.png";